/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Lowestprices1Inputs */

const he_nav_lowestprices1 = /** @type {(inputs: Nav_Lowestprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצרים במחיר הכי זול`)
};

const en_nav_lowestprices1 = /** @type {(inputs: Nav_Lowestprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest Prices`)
};

/**
* | output |
* | --- |
* | "Lowest Prices" |
*
* @param {Nav_Lowestprices1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const nav_lowestprices1 = /** @type {((inputs?: Nav_Lowestprices1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Lowestprices1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_lowestprices1(inputs)
	return en_nav_lowestprices1(inputs)
});
export { nav_lowestprices1 as "nav_lowestPrices" }